import NavBar from "../NavBar"
import './style.css'

export const Header = () => {
    return (
        <div className="header-container page-container" >
            <NavBar />
        </div>
    )
}